import { useMemo } from 'react'
import { useElementTypes } from '@editorHooks'
import { buildHiddenSupportPositionPredicate } from '../utils'

/**
 * Predicate that tells whether a support (identified by its relative position)
 * should be hidden because it is the analytical upper support of a rip or column.
 * Shared by the supports grid, the "Auflager" and the "Charakteristische
 * Auflagerkräfte" tables so they stay in sync.
 */
export const useHiddenSupportPosition = (
  elementId?: string,
): ((relativePosition?: string | number) => boolean) => {
  const elementTypesByGuid = useElementTypes()
  const rootElementType = elementId ? elementTypesByGuid[elementId] : undefined

  return useMemo(() => buildHiddenSupportPositionPredicate(rootElementType), [rootElementType])
}
